window.chicAtelierBaseCatalog = {
  "version": 1,
  "catalogId": "chic-bases-20261011",
  "currency": "USD",
  "bases": [
    {
      "code": "A1",
      "productId": "gid://shopify/Product/15421346808087",
      "variantId": "67738001801495",
      "handle": "chic-heart-centerpiece-oval-link-bracelet",
      "title": "Heart Centerpiece Oval-Link Bracelet",
      "piece": "bracelet",
      "price": 6000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 6,
      "linkStyle": "oval-fine",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-a1-primary-white-mirror-20261012.png?v=1791815035",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extender present",
      "fixedHeart": true,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-bracelets-source-20261011.jpg?v=1791755770",
      "hardwareCrop": "246 372 228 264",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536,
      "fixedHeartPhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-bracelets-source-20261011.jpg?v=1791755770",
      "fixedHeartCrop": "330 1070 142 168",
      "fixedHeartImageWidth": 1157,
      "fixedHeartImageHeight": 1536
    },
    {
      "code": "A2",
      "productId": "gid://shopify/Product/15421346840855",
      "variantId": "67738001834263",
      "handle": "chic-bold-oval-link-bracelet",
      "title": "Bold Oval-Link Bracelet",
      "piece": "bracelet",
      "price": 6000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 7,
      "linkStyle": "oval-bold",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-a2-primary-white-mirror-20261012.png?v=1791814880",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extension to be confirmed",
      "fixedHeart": false,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-bracelets-source-20261011.jpg?v=1791755770",
      "hardwareCrop": "690 389 194 287",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536
    },
    {
      "code": "N1",
      "productId": "gid://shopify/Product/15421346873623",
      "variantId": "67738001932567",
      "handle": "chic-delicate-oval-link-charm-necklace",
      "title": "Delicate Oval-Link Charm Necklace",
      "piece": "necklace",
      "price": 8000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 9,
      "linkStyle": "oval-fine",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-n1-primary-white-mirror-20261012.png?v=1791814891",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extender present",
      "fixedHeart": false,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-necklaces-source-20261011.jpg?v=1791755777",
      "hardwareCrop": "287 410 132 280",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536
    },
    {
      "code": "N2",
      "productId": "gid://shopify/Product/15421346906391",
      "variantId": "67738001965335",
      "handle": "chic-signature-oval-link-charm-necklace",
      "title": "Signature Oval-Link Charm Necklace",
      "piece": "necklace",
      "price": 8000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 9,
      "linkStyle": "oval-bold",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-n2-primary-white-mirror-20261012.png?v=1791814907",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extension to be confirmed",
      "fixedHeart": false,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-necklaces-source-20261011.jpg?v=1791755777",
      "hardwareCrop": "432 575 116 158",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536
    },
    {
      "code": "N3",
      "productId": "gid://shopify/Product/15421346971927",
      "variantId": "67738002030871",
      "handle": "chic-textured-link-charm-necklace",
      "title": "Textured Link Charm Necklace",
      "piece": "necklace",
      "price": 9000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 9,
      "linkStyle": "oval-small",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-n3-primary-white-mirror-20261012.png?v=1791814947",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extender present",
      "fixedHeart": false,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-necklaces-source-20261011.jpg?v=1791755777",
      "hardwareCrop": "584 491 129 279",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536
    },
    {
      "code": "N4",
      "productId": "gid://shopify/Product/15421347037463",
      "variantId": "67738002096407",
      "handle": "chic-bold-link-charm-necklace",
      "title": "Bold Link Charm Necklace",
      "piece": "necklace",
      "price": 10000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 9,
      "linkStyle": "oval-dense",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-n4-primary-white-mirror-20261012.png?v=1791814965",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extension to be confirmed",
      "fixedHeart": false,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-necklaces-source-20261011.jpg?v=1791755777",
      "hardwareCrop": "710 544 142 218",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536
    },
    {
      "code": "C1",
      "productId": "gid://shopify/Product/15421347135767",
      "variantId": "67738003013911",
      "handle": "chic-rigid-collar-necklace",
      "title": "Rigid Collar Choker",
      "piece": "collar",
      "price": 8000,
      "status": "DRAFT",
      "previewOnly": true,
      "capacity": 1,
      "linkStyle": "collar",
      "photo": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-c1-primary-white-mirror-20261012.png?v=1791814983",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "crop": "0 0 1254 1254",
      "caption": "Length to be confirmed · Extender present",
      "fixedHeart": false,
      "hardwarePhoto": "https://cdn.shopify.com/s/files/1/0942/0396/9815/files/chic-base-necklaces-source-20261011.jpg?v=1791755777",
      "hardwareCrop": "371 68 393 106",
      "hardwareImageWidth": 1157,
      "hardwareImageHeight": 1536
    }
  ]
};
